module.exports = __webpack_public_path__ + "static/media/man.6976df5d.svg";